@file:OptIn(InternalResourceApi::class)

package com.flowyride.feature.settings.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.flowyride.feature.settings.resources/"

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 20),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31, 26),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113, 26),
      ))
    }

@delegate:ResourceContentHash(792_027_800)
internal val Res.string.delete_confirm: StringResource by lazy {
      StringResource("string:delete_confirm", "delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58, 54),
      ))
    }

@delegate:ResourceContentHash(977_008_640)
internal val Res.string.edit_place_title: StringResource by lazy {
      StringResource("string:edit_place_title", "edit_place_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140, 48),
      ))
    }

@delegate:ResourceContentHash(2_009_770_735)
internal val Res.string.error_places_load: StringResource by lazy {
      StringResource("string:error_places_load", "error_places_load", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189, 73),
      ))
    }

@delegate:ResourceContentHash(-469_514_575)
internal val Res.string.error_places_save: StringResource by lazy {
      StringResource("string:error_places_save", "error_places_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 263, 89),
      ))
    }

@delegate:ResourceContentHash(1_325_602_909)
internal val Res.string.place_color: StringResource by lazy {
      StringResource("string:place_color", "place_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353, 31),
      ))
    }

@delegate:ResourceContentHash(-1_700_229_944)
internal val Res.string.place_emoji: StringResource by lazy {
      StringResource("string:place_emoji", "place_emoji", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 461, 27),
      ))
    }

@delegate:ResourceContentHash(-665_392_675)
internal val Res.string.place_emoji_custom: StringResource by lazy {
      StringResource("string:place_emoji_custom", "place_emoji_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 385, 42),
      ))
    }

@delegate:ResourceContentHash(-1_507_273_737)
internal val Res.string.place_emoji_none: StringResource by lazy {
      StringResource("string:place_emoji_none", "place_emoji_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 428, 32),
      ))
    }

@delegate:ResourceContentHash(2_609_076)
internal val Res.string.place_name: StringResource by lazy {
      StringResource("string:place_name", "place_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 489, 22),
      ))
    }

@delegate:ResourceContentHash(1_396_643_626)
internal val Res.string.places_empty: StringResource by lazy {
      StringResource("string:places_empty", "places_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 512, 132),
      ))
    }

@delegate:ResourceContentHash(-1_470_568_671)
internal val Res.string.places_hint: StringResource by lazy {
      StringResource("string:places_hint", "places_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 645, 111),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 757, 29),
      ))
    }

@delegate:ResourceContentHash(715_359_707)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 28),
      ))
    }

@delegate:ResourceContentHash(-1_693_728_645)
internal val Res.string.section_account: StringResource by lazy {
      StringResource("string:section_account", "section_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 816, 31),
      ))
    }

@delegate:ResourceContentHash(927_477_283)
internal val Res.string.section_places: StringResource by lazy {
      StringResource("string:section_places", "section_places", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 848, 54),
      ))
    }

@delegate:ResourceContentHash(-250_818_688)
internal val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 903, 38),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("back", Res.string.back)
  map.put("cancel", Res.string.cancel)
  map.put("delete", Res.string.delete)
  map.put("delete_confirm", Res.string.delete_confirm)
  map.put("edit_place_title", Res.string.edit_place_title)
  map.put("error_places_load", Res.string.error_places_load)
  map.put("error_places_save", Res.string.error_places_save)
  map.put("place_color", Res.string.place_color)
  map.put("place_emoji", Res.string.place_emoji)
  map.put("place_emoji_custom", Res.string.place_emoji_custom)
  map.put("place_emoji_none", Res.string.place_emoji_none)
  map.put("place_name", Res.string.place_name)
  map.put("places_empty", Res.string.places_empty)
  map.put("places_hint", Res.string.places_hint)
  map.put("retry", Res.string.retry)
  map.put("save", Res.string.save)
  map.put("section_account", Res.string.section_account)
  map.put("section_places", Res.string.section_places)
  map.put("settings_title", Res.string.settings_title)
}
